import { Component, OnInit } from '@angular/core';
import {ResetVisualizerDataCommand} from '@shared/commands/dashboard.command';
import {ResetAnalyticsReport} from '@features/dashboard/store/action/dashboard-actions';
import {Store} from '@ngrx/store';
import {IDashboardState} from '@features/dashboard/store/reducer/dashboard-reducer';

@Component({
    standalone: false,
    selector: 'app-oic-analytics',
  templateUrl: './oic-analytics.component.html',
  styleUrls: ['./oic-analytics.component.scss']
})
export class OicAnalyticsComponent implements OnInit {

  constructor(private dashboardStore: Store<IDashboardState>) { }

  ngOnInit(): void {
  }
}
